import { signalRService } from "./signalr.service";
import { debugLog } from "../common/utils/debug";
import { speechToTextSileroService } from "./speech-to-text-silero.service";
import { AvatarSettings } from "../types";

/**
 * Connection manager for SignalR-based communication
 * !Wire between the client and the server
 */
class ConnectionManager {
  private sessionId: string | null = null;

  async connect(userId: string, avatarSettings: AvatarSettings, sessionId: string): Promise<any> {
    try {
      this.sessionId = sessionId;
      const result = await signalRService.connect(userId, avatarSettings, sessionId);
      return result;
    } catch (error) {
      throw error;
    }
  }

  async sendTextInput(message: string): Promise<void> {
    await signalRService.sendTextInput(message);
  }

  async stopProcessing(): Promise<void> {
    await signalRService.stopProcessing();
  }

  async pauseSession(): Promise<void> {
    await signalRService.pauseSession();
  }

  async resumeSession(): Promise<void> {
    await signalRService.resumeSession();
  }

  async disconnect(): Promise<void> {
    // eslint-disable-next-line no-console
    debugLog("🔌 [ConnectionManager] Disconnecting - stopping all audio services...");
    
    // Stop local audio recording first
    speechToTextSileroService.stopRecording();
    
    // Stop backend streaming recognition
    await signalRService.stopStreamingRecognition();
    
    // Finally disconnect SignalR
    await signalRService.disconnect();
    
    // eslint-disable-next-line no-console
    debugLog("✅ [ConnectionManager] All services stopped and disconnected");
  }

  on(event: string, callback: (data: any) => void): void {
    signalRService.on(event, callback);
  }

  off(event: string, callback?: (data: any) => void): void {
    signalRService.off(event, callback);
  }

  isConnected(): boolean {
    return signalRService.isConnected();
  }

  getConnectionState(): string {
    return signalRService.getConnectionState();
  }

  getTransportType(): "SignalR" {
    return "SignalR";
  }

  setSessionId(sessionId: string): void {
    this.sessionId = sessionId;
  }

  getSessionId(): string | null {
    return this.sessionId;
  }

  endSession(): void {
    this.sessionId = null;
  }

  getSocket(): any {
    return {
      connected: signalRService.isConnected(),
    };
  }
}

export const connectionManager = new ConnectionManager();
